export default "__VITE_ASSET__tZC9Rrnt__"